export const environment = {
  serviceWorkerEnabled: true,
  production: true,
  apiUrl: 'service/v1/',
  logLevel: 7,
};
